/**
 * /researcher/leaderboard — top 10 by XP, all-time + last 30 days.
 *
 * Opt-in: only researchers who enabled their public profile appear.
 * Two columns so it's clear who's hot lately vs who's the established
 * heavyweight.
 */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api.js'
import { usePageTitle } from '../hooks/usePageTitle.js'

export default function LeaderboardPage() {
  usePageTitle('Researcher leaderboard')
  const [data, setData] = useState(null)
  const [err, setErr]   = useState(null)

  useEffect(() => {
    api.get('/researcher/leaderboard/top?limit=10')
      .then(setData)
      .catch(e => setErr(e.message || 'Failed to load leaderboard'))
  }, [])

  if (err) return (
    <div className="page" style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
      {err}
    </div>
  )
  if (!data) return <div className="page" style={{ padding: '2rem', color: 'var(--text-muted)' }}>Loading…</div>

  return (
    <div className="page leaderboard-page">
      <header className="leaderboard-page__header">
        <div className="leaderboard-page__eyebrow">Genealogic · researchers</div>
        <h1 className="leaderboard-page__title">Leaderboard</h1>
        <p className="leaderboard-page__intro">
          Top researchers ranked by XP. Only researchers who opted in to a
          public profile appear here.
        </p>
      </header>

      <div className="leaderboard-page__grid">
        <LeaderboardColumn title="Last 30 days" rows={data.last_30_days} emptyMsg="No activity in the last 30 days yet." />
        <LeaderboardColumn title="All time"     rows={data.all_time}     emptyMsg="No public researchers yet." />
      </div>
    </div>
  )
}

function LeaderboardColumn({ title, rows, emptyMsg }) {
  return (
    <section className="leaderboard-page__col">
      <h2 className="leaderboard-page__col-title">{title}</h2>
      {rows.length === 0 ? (
        <div className="leaderboard-page__empty">{emptyMsg}</div>
      ) : (
        <ol className="leaderboard-page__list">
          {rows.map((r, i) => (
            <li key={r.id} className="leaderboard-page__row">
              <span className={`leaderboard-page__rank leaderboard-page__rank--${i + 1}`}>#{i + 1}</span>
              <span className="leaderboard-page__name">
                {r.public_profile_slug
                  ? <Link to={`/researcher/${r.public_profile_slug}`}>{r.name || 'Researcher'}</Link>
                  : (r.name || 'Researcher')}
                {r.tier === 'researcher' && (
                  <span className="leaderboard-page__pro" title="Pro Researcher">👑</span>
                )}
              </span>
              <span className="leaderboard-page__xp">{r.xp} XP</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
